import React from 'react';
import 'date-fns';
import {TextField,} from '@mui/material';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import FolderSelector from "../../../folders/FolderSelector";

function SurveyForm(props) {
  const { item, handleItemChange, folderList, addFolder, validations, classes } = props;

  return (
      <div style={{display:"flex", flexDirection:"column", gap:"1rem", minWidth:'calc(min(18rem, 100%))', flexGrow: 1}}>
        <TextField
          fullWidth
          variant="outlined"
          label="Name"
          value={item.name || ""}
          onChange={(e) => handleItemChange({...item, name: e.target.value})}
          size="small"
          margin="none"
          InputLabelProps={{shrink: true}}
          required
          error={validations.name && !item.name}
        />
        <TextField
          fullWidth
          variant="outlined"
          label="Description"
          multiline minRows={8} maxRows={20}
          value={item.description || ""}
          onChange={(e) => handleItemChange({...item, description: e.target.value})}
          margin="none"
          InputLabelProps={{shrink: true}}
          // required
          // error={validations.description && !item.description}
        />
        <div className={classes.row}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              label="Date"
              inputFormat="MM/dd/yyyy"
              value={typeof item.date === "string" ? new Date(item.date.replace(/-/g, '/')) : item.date}
              onChange={(newValue) => handleItemChange({ ...item, date: newValue })}
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  size="small"
                  margin="none"
                  required
                  error={validations.date && !item.date}
                />
              )}
            />
          </LocalizationProvider>
          <FolderSelector
            label="Folder"
            margin="none"
            selectedFolder={item.folder}
            folderList={folderList}
            addFolder={addFolder}
            handleFolderSelect={(newVal) => handleItemChange({...item, folder: newVal})}
          />
        </div>
      </div>
  );
}

export default SurveyForm;
